import { Col, Row, Table } from 'antd';
import { CustomPagination, PageHeaderActions } from '@/components';
import CommonDrawer from '@/components/CommonDrawer';
import type { SensorData } from '@/apis/settings';
import CustomDeleteModal from '../../../Modals/CustomDeleteModal.jsx';
import type { SensorsViewProps } from '../types';
import { SensorForm, SensorProviderDetails } from '.';
import useTableScroll from '@/hooks/useTableScroll.js';

const SensorsView: React.FC<SensorsViewProps> = ({ controller, title }) => {
  const tableScroll = useTableScroll();
  const {
    columns,
    credentials,
    credentialDrawerView,
    deleteModalVisible,
    drawerOpen,
    getProviderImagePath,
    handleAddProvider,
    handleCloseDrawer,
    handleConfirmDelete,
    handleDrawerBack,
    handleSelectProvider,
    handlePageChange,
    handleSearchChange,
    isEditing,
    maxPageSize,
    modalState,
    page,
    rangeEnd,
    rangeStart,
    searchQuery,
    selectedSensor,
    sensorDDLLoading,
    sensorFormList,
    sensorList,
    sensorsPermissions,
    setCredentialDrawerView,
    setDeleteModalVisible,
    setModalState,
    setSearchQuery,
    setSelectedSensor,
    setShowProviderDetails,
    showProviderDetails,
    t,
    totalPages,
  } = controller;

  return (
    <>
      <div className='settings-content-wrapper'>
        <PageHeaderActions
          showToggle={false}
          title={title}
          totalCount={maxPageSize}
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          addButtonText={t('add')}
          onSearchChange={handleSearchChange}
          onSearchClear={handleSearchChange}
          showAddButton={sensorsPermissions?.is_create}
          onAddClick={handleAddProvider}
        />

        <Table
          columns={columns}
          dataSource={sensorList}
          pagination={false}
          className='settings-table sensors-settings-table settings-table-action-cols'
          tableLayout='fixed'
          scroll={tableScroll}
        />

        {sensorList.length > 0 && (
          <Row className='sensor-pagination-row' justify='center'>
            <Col>
              <CustomPagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        )}
      </div>

      <CustomDeleteModal
        visible={deleteModalVisible || modalState.delete}
        onClose={() => {
          setDeleteModalVisible(false);
          setModalState((prev) => ({ ...prev, delete: false }));
        }}
        onConfirm={handleConfirmDelete}
        title={`${t('removeConnection')} ${selectedSensor?.sensor_name}`}
        message={t('removeSensorMessage')}
        cancelText={t('cancel')}
        confirmText={t('delete')}
        confirmColor='var(--danger)'
      />

      <CommonDrawer
        open={drawerOpen}
        onClose={handleCloseDrawer}
        onBack={
          showProviderDetails &&
          (credentialDrawerView === 'credential' || !isEditing)
            ? handleDrawerBack
            : undefined
        }
      >
        {showProviderDetails ? (
          <SensorProviderDetails
            credentials={credentials}
            getSensorImagePath={getProviderImagePath}
            setModalState={setModalState}
            providerData={selectedSensor}
            onClose={handleCloseDrawer}
            edit={isEditing}
            drawerCredentialView={credentialDrawerView}
            setDrawerCredentialView={setCredentialDrawerView}
          />
        ) : (
          <SensorForm
            getSensorImagePath={getProviderImagePath}
            loading={sensorDDLLoading}
            onSensorSelect={handleSelectProvider}
            sensorList={sensorFormList}
            setSelectedSensor={(sensor) =>
              setSelectedSensor(sensor as SensorData)
            }
            setShowProviderDetails={setShowProviderDetails}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        )}
      </CommonDrawer>

      {/*
        SensorConnectionModal flow
      */}
    </>
  );
};

export default SensorsView;
